import * as actionTypes from '../types/admin';

export function getUsersList(payload) {
  return {
    type: actionTypes.GET_USERS_LIST,
    payload
  };
}
export function getUsersListSuccess(payload) {
  return {
    type: actionTypes.GET_USERS_LIST_SUCCESS,
    payload
  };
}
export function getUsersListFail(payload) {
  return {
    type: actionTypes.GET_USERS_LIST_FAIL,
    payload
  };
}

export function getUsersOnRole(payload) {
  return {
    type: actionTypes.GET_USERS_ON_ROLE,
    payload
  };
}
export function getUsersOnRoleSuccess(payload) {
  return {
    type: actionTypes.GET_USERS_ON_ROLE_SUCCESS,
    payload
  };
}
export function getUsersOnRoleFail(payload) {
  return {
    type: actionTypes.GET_USERS_ON_ROLE_FAIL,
    payload
  };
}

export function createOrUpdateUser(payload) {
  return {
    type: actionTypes.CREATE_OR_UPDATE_USER,
    payload
  };
}
export function createOrUpdateUserSuccess(payload) {
  return {
    type: actionTypes.CREATE_OR_UPDATE_USER_SUCCESS,
    payload
  };
}
export function createOrUpdateUserFail(payload) {
  return {
    type: actionTypes.CREATE_OR_UPDATE_USER_FAIL,
    payload
  };
}
export function createOrUpdateUserClear(payload) {
  return {
    type: actionTypes.CREATE_OR_UPDATE_USER_CLEAR,
    payload
  };
}

export function createRole(payload) {
  return {
    type: actionTypes.CREATE_ROLE,
    payload
  };
}
export function createRoleSuccess(payload) {
  return {
    type: actionTypes.CREATE_ROLE_SUCCESS,
    payload
  };
}
export function createRoleFail(payload) {
  return {
    type: actionTypes.CREATE_ROLE_FAIL,
    payload
  };
}
export function createRoleClear(payload) {
  return {
    type: actionTypes.CREATE_ROLE_CLEAR,
    payload
  };
}

export function getRolesList(payload) {
  return {
    type: actionTypes.GET_ROLES_LIST,
    payload
  };
}
export function getRolesListSuccess(payload) {
  return {
    type: actionTypes.GET_ROLES_LIST_SUCCESS,
    payload
  };
}
export function getRolesListFail(payload) {
  return {
    type: actionTypes.GET_ROLES_LIST_FAIL,
    payload
  };
}
export function updateRole(payload) {
  return {
    type: actionTypes.UPDATE_ROLE,
    payload
  };
}
export function updateRoleSuccess(payload) {
  return {
    type: actionTypes.UPDATE_ROLE_SUCCESS,
    payload
  };
}
export function updateRoleFail(payload) {
  return {
    type: actionTypes.UPDATE_ROLE_FAIL,
    payload
  };
}
export function updateRoleClear(payload) {
  return {
    type: actionTypes.UPDATE_ROLE_CLEAR,
    payload
  };
}

export function getRolesOnUser(payload) {
  return {
    type: actionTypes.GET_ROLES_ON_USER,
    payload
  };
}
export function getRolesOnUserSuccess(payload) {
  return {
    type: actionTypes.GET_ROLES_ON_USER_SUCCESS,
    payload
  };
}
export function getRolesOnUserFail(payload) {
  return {
    type: actionTypes.GET_ROLES_ON_USER_FAIL,
    payload
  };
}

export function addRoleOnUser(payload) {
  return {
    type: actionTypes.ADD_ROLE_ON_USER,
    payload
  };
}
export function addRoleOnUserSuccess(payload) {
  return {
    type: actionTypes.ADD_ROLE_ON_USER_SUCCESS,
    payload
  };
}
export function addRoleOnUserFail(payload) {
  return {
    type: actionTypes.ADD_ROLE_ON_USER_FAIL,
    payload
  };
}
export function addRoleOnUserClear(payload) {
  return {
    type: actionTypes.ADD_ROLE_ON_USER_CLEAR,
    payload
  };
}

export function deleteRoleOnUser(payload) {
  return {
    type: actionTypes.DELETE_ROLE_ON_USER,
    payload
  };
}
export function deleteRoleOnUserSuccess(payload) {
  return {
    type: actionTypes.DELETE_ROLE_ON_USER_SUCCESS,
    payload
  };
}
export function deleteRoleOnUserFail(payload) {
  return {
    type: actionTypes.DELETE_ROLE_ON_USER_FAIL,
    payload
  };
}
export function deleteRoleOnUserClear(payload) {
  return {
    type: actionTypes.DELETE_ROLE_ON_USER_CLEAR,
    payload
  };
}

export function plantVisit(payload) {
  return {
    type: actionTypes.PLANT_VISIT,
    payload
  };
}

export function getPiecesList(payload) {
  return {
    type: actionTypes.GET_PIECES_LIST,
    payload
  };
}
export function getPiecesListSuccess(payload) {
  return {
    type: actionTypes.GET_PIECES_LIST_SUCCESS,
    payload
  };
}
export function getPiecesListFail(payload) {
  return {
    type: actionTypes.GET_PIECES_LIST_FAIL,
    payload
  };
}

export function changePiecesPlant(payload) {
  return {
    type: actionTypes.CHANGE_PIECES_PLANT,
    payload
  };
}
export function changePiecesPlantSuccess(payload) {
  return {
    type: actionTypes.CHANGE_PIECES_PLANT_SUCCESS,
    payload
  };
}
export function changePiecesPlantFail(payload) {
  return {
    type: actionTypes.CHANGE_PIECES_PLANT_FAIL,
    payload
  };
}

export function changePiecesStatus(payload) {
  return {
    type: actionTypes.CHANGE_PIECES_STATUS,
    payload
  };
}
export function changePiecesStatusSuccess(payload) {
  return {
    type: actionTypes.CHANGE_PIECES_STATUS_SUCCESS,
    payload
  };
}
export function changePiecesStatusFail(payload) {
  return {
    type: actionTypes.CHANGE_PIECES_STATUS_FAIL,
    payload
  };
}

export function getStatusesList(payload) {
  return {
    type: actionTypes.GET_STATUSES_LIST,
    payload
  };
}
export function getStatusesListSuccess(payload) {
  return {
    type: actionTypes.GET_STATUSES_LIST_SUCCESS,
    payload
  };
}
export function getStatusesListFail(payload) {
  return {
    type: actionTypes.GET_PIECES_LIST_FAIL,
    payload
  };
}
export function getVisitsUser(payload) {
  return {
    type: actionTypes.GET_VISITS_USER,
    payload
  };
}
export function getVisitsUserSuccess(payload) {
  return {
    type: actionTypes.GET_VISITS_USER_SUCCESS,
    payload
  };
}
export function getVisitsUserFail(payload) {
  return {
    type: actionTypes.GET_VISITS_USER_FAIL,
    payload
  };
}
export function getVisitsUserClear(payload) {
  return {
    type: actionTypes.GET_VISITS_USER_CLEAR,
    payload
  };
}

export function getPermissionsOnRole(payload) {
  return {
    type: actionTypes.GET_PERMISSIONS_ON_ROLE,
    payload
  };
}
export function getPermissionsOnRoleSuccess(payload) {
  return {
    type: actionTypes.GET_PERMISSIONS_ON_ROLE_SUCCESS,
    payload
  };
}
export function getPermissionsOnRoleFail(payload) {
  return {
    type: actionTypes.GET_PERMISSIONS_ON_ROLE_FAIL,
    payload
  };
}

export function getPermissions(payload) {
  return {
    type: actionTypes.GET_PERMISSIONS,
    payload
  };
}
export function getPermissionsSuccess(payload) {
  return {
    type: actionTypes.GET_PERMISSIONS_SUCCESS,
    payload
  };
}
export function getPermissionsFail(payload) {
  return {
    type: actionTypes.GET_PERMISSIONS_FAIL,
    payload
  };
}

export function getPermissionValues(payload) {
  return {
    type: actionTypes.GET_PERMISSION_VALUES,
    payload
  };
}
export function getPermissionValuesSuccess(payload) {
  return {
    type: actionTypes.GET_PERMISSION_VALUES_SUCCESS,
    payload
  };
}
export function getPermissionValuesFail(payload) {
  return {
    type: actionTypes.GET_PERMISSION_VALUES_FAIL,
    payload
  };
}

export function addPermissionOnRole(payload) {
  return {
    type: actionTypes.ADD_PERMISSION_ON_ROLE,
    payload
  };
}
export function addPermissionOnRoleSuccess(payload) {
  return {
    type: actionTypes.ADD_PERMISSION_ON_ROLE_SUCCESS,
    payload
  };
}
export function addPermissionOnRoleFail(payload) {
  return {
    type: actionTypes.ADD_PERMISSION_ON_ROLE_FAIL,
    payload
  };
}
export function addPermissionOnRoleClear(payload) {
  return {
    type: actionTypes.ADD_PERMISSION_ON_ROLE_CLEAR,
    payload
  };
}

export function deletePermissionOnRole(payload) {
  return {
    type: actionTypes.DELETE_PERMISSION_ON_ROLE,
    payload
  };
}
export function deletePermissionOnRoleSuccess(payload) {
  return {
    type: actionTypes.DELETE_PERMISSION_ON_ROLE_SUCCESS,
    payload
  };
}
export function deletePermissionOnRoleFail(payload) {
  return {
    type: actionTypes.DELETE_PERMISSION_ON_ROLE_FAIL,
    payload
  };
}
export function deletePermissionOnRoleClear(payload) {
  return {
    type: actionTypes.DELETE_PERMISSION_ON_ROLE_CLEAR,
    payload
  };
}
